import moment from 'moment';

export const getMonthlyChartLabels = (items = []) =>
    items.map((item) => formatMonthLabel(item.date));

export const formatMonthLabel = (date) => {
    if (date == null) {
        return date;
    }

    const parsed = moment(date, ['MMMM - YYYY', 'YYYY-MM-DD', 'YYYY-MM'], true);
    if (parsed.isValid()) {
        return parsed.format('MMM YY');
    }

    return date;
};

export const getPeriodAverageValue = (chartData) => chartData.period_avg;
